import {RecipientRolesEnum} from '../../../src/models/api/recipientModel';
import {isExistingModifier, ModifiersEnum} from './searchModifiersHelpers';

/*
 * Constants.
 */

export const searchableAttribute = 'data-searchable';

export const searchableAttrsSubject = {
  [searchableAttribute]: true,
  [`${searchableAttribute}-${ModifiersEnum.SUBJECT}`]: true,
};

export const searchableAttrsBody = {
  [searchableAttribute]: true,
  [`${searchableAttribute}-${ModifiersEnum.BODY}`]: true,
};

export const searchableAttrsFrom = makeSearchableAttrsForRole(RecipientRolesEnum.FROM);

/*
 * Helpers.
 */

export function makeSearchableAttrsForRole(role: RecipientRolesEnum) {
  const searchableAttrs: Record<string, boolean> = {
    [searchableAttribute]: true,
    [`${searchableAttribute}-${ModifiersEnum.RECIPIENT}`]: true,
  };

  // If role has a related modifier, add it as a searchable attribute.
  if (isExistingModifier(role)) {
    searchableAttrs[`${searchableAttribute}-${role}`] = true;
  }

  return searchableAttrs;
}
